import { useEffect, useState } from "react";

export function useMediaQuery(query: string) {
	const [matches, setMatches] = useState(() => matchMedia(query).matches);

	useEffect(() => {
		const media = matchMedia(query);
		const handler = () => setMatches(media.matches);
		media.addEventListener("change", handler);
		return () => media.removeEventListener("change", handler);
	}, [query]);

	return matches;
}